module.exports = __webpack_public_path__ + "img/gigilogo.e235cbc2.svg";